import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import FiltersContentLoader from '../../../../components/FiltersContentLoader';
import LoadMask from '../../../../components/LoadMask';
import PagePagination from '../../../../components/PagePagination';
import ENDPOINT from '../../../../constants/endpoints';
import {useGrid} from '../../../../hooks/useGrid';
import ApplicationWidgetItem from './components/ApplicationWidgetItem';

const ApplicationWidget = forwardRef((props, ref) => {
  const { id, isProject, isJob } = props;
  const grid = useGrid(
    isJob
      ? ENDPOINT.COLLECTION.CANDIDATE_PROFILE_JOB_APPLICATIONS
      : ENDPOINT.COLLECTION.CANDIDATE_PROFILE_PROJECT_APPLICATIONS,
    null,
    false
  );

  const {
    data: { isFetching },
  } = useGrid(
    isJob
      ? ENDPOINT.COLLECTION.CANDIDATE_PROFILE_JOB_APPLICATIONS
      : ENDPOINT.COLLECTION.CANDIDATE_PROFILE_PROJECT_APPLICATIONS,
    null,
    false
  );

  useEffect(() => {
    grid.actions.fetch({ id });
  }, []);

  useImperativeHandle(ref, () => ({
    reload: () => {
      grid.actions.fetch();
    },
  }));

  return !isFetching ? (
    Number(grid.data.rowsCount) > 0 ? (
      <div className="sidebar__widget application-widget">
        {grid.data.isFetching && <LoadMask relative />}

        <div className="sidebar__block">
          <h3 className="sidebar__title">
            {isProject ? 'Projects' : 'Application'}
          </h3>
        </div>

        <div className="sidebar__block">
          <div className="sidebar__table">
            {grid.data.rows.map(record => (
              <ApplicationWidgetItem
                isJob={isJob}
                isProject={isProject}
                key={record.ProcessID}
                record={record}
              />
            ))}
          </div>
          {Number(grid.data.rowsCount) > Number(grid.data.perPage) && (
            <div className="sidebar__pagination">
              <PagePagination
                page={grid.data.page}
                perPage={grid.data.perPage}
                count={grid.data.rowsCount}
                pageRangeDisplayed={3}
                controlFunc={grid.actions.readPage}
                hideFirstLastPages={false}
                hideNavigation={true}
                minimalStyle={true}
                scrollToTop={false}
              />
            </div>
          )}
        </div>
      </div>
    ) : null
  ) : (
    <FiltersContentLoader />
  );
});

ApplicationWidget.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isProject: props =>
    !props.isJob && !props.isProject
      ? new Error(
          `One of props 'isProject' or 'isJob' was not specified in 'ApplicationWidget'.`
        )
      : null,
  isJob: props =>
    !props.isJob && !props.isProject
      ? new Error(
          `One of props 'isProject' or 'isJob' was not specified in 'ApplicationWidget'.`
        )
      : null,
};

export default ApplicationWidget;
